import type { Color } from '@xox/shared'

/** Full class strings so Tailwind's scanner picks them up. */
export const COLOR_CLASSES: Record<Color, string> = {
  rose: 'bg-rose-100 text-rose-700 dark:bg-rose-950/70 dark:text-rose-200',
  orange: 'bg-orange-100 text-orange-700 dark:bg-orange-950/70 dark:text-orange-200',
  amber: 'bg-amber-100 text-amber-700 dark:bg-amber-950/70 dark:text-amber-200',
  lime: 'bg-lime-100 text-lime-700 dark:bg-lime-950/70 dark:text-lime-200',
  emerald: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/70 dark:text-emerald-200',
  sky: 'bg-sky-100 text-sky-700 dark:bg-sky-950/70 dark:text-sky-200',
  violet: 'bg-violet-100 text-violet-700 dark:bg-violet-950/70 dark:text-violet-200',
  pink: 'bg-pink-100 text-pink-700 dark:bg-pink-950/70 dark:text-pink-200',
}

/** T-shirt fill for the ice skater; the variables live in index.css (`@theme static`). */
export const SHIRT_FILL: Record<Color, string> = {
  rose: 'var(--shirt-rose)',
  orange: 'var(--shirt-orange)',
  amber: 'var(--shirt-amber)',
  lime: 'var(--shirt-lime)',
  emerald: 'var(--shirt-emerald)',
  sky: 'var(--shirt-sky)',
  violet: 'var(--shirt-violet)',
  pink: 'var(--shirt-pink)',
}

export const SWATCH_CLASSES: Record<Color, string> = {
  rose: 'bg-rose-400',
  orange: 'bg-orange-400',
  amber: 'bg-amber-400',
  lime: 'bg-lime-400',
  emerald: 'bg-emerald-400',
  sky: 'bg-sky-400',
  violet: 'bg-violet-400',
  pink: 'bg-pink-400',
}
